import React from 'react'
import ReactDOM from 'react-dom'
import { createRoot } from "react-dom/client";
import Generator from "./components/Generator";
import './assets/style.scss'
import { BrowserRouter as Router } from 'react-router-dom'

document.addEventListener('DOMContentLoaded', () => {
	let generator = document.querySelector("#namnlapp-generator")
	if (generator) {
		const root = createRoot(generator),
			price = generator.getAttribute('data-price'),
			name = generator.getAttribute('data-name'),
			type = generator.getAttribute('data-type'),
			id = generator.getAttribute('data-id'),
			description = generator.getAttribute('data-description');
		root.render(
			<Router>
				<Generator price={price} name={name} id={id} type={type} description={description} />
			</Router>
		)
	}
})